'use client';

import { Fragment } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { KeenIcon } from '../keenicons';
import { FormattedMessage } from 'react-intl';

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

const ToolbarBreadcrumbs = () => {
  const pathname = usePathname();
  const pathSegments = pathname.split('/').filter(Boolean);

  const items = pathSegments.map((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/');
    return {
      title: capitalize(decodeURIComponent(segment.replace(/[-_]/g, ' '))),
      path,
    };
  });

  return (
    <div className="flex [.header_&]:below-lg:hidden items-center gap-1.25 text-xs lg:text-sm font-medium mb-2.5 lg:mb-0">
      <div className="breadcrumb flex items-center gap-1">
        <Link href="/" className="text-gray-600 hover:text-primary">
          <FormattedMessage id="HOME" />
        </Link>
        {items.length > 0 && <KeenIcon icon="right" className="text-gray-500 text-3xs" />}
        {items.map((item, index) => (
          <Fragment key={index}>
            {index !== items.length - 1 ? (
              <Link
                href={item.path}
                className="flex items-center gap-1 text-gray-600 hover:text-primary"
              >
                {item.title}
              </Link>
            ) : (
              <span className="text-gray-700">{item.title}</span>
            )}
            {index !== items.length - 1 && (
              <KeenIcon icon="right" className="text-gray-500 text-3xs" />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export { ToolbarBreadcrumbs };
